import React from 'react';
import { StyledButton, ButtonIcon } from './Button.styles';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  loading = false,
  leftIcon,
  rightIcon,
  onClick,
  type = 'button',
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      {...props}
    >
      {loading ? (
        <>
          <ButtonIcon className="spin">⟳</ButtonIcon>
          Loading...
        </>
      ) : (
        <>
          {leftIcon && <ButtonIcon>{leftIcon}</ButtonIcon>}
          {children}
          {rightIcon && <ButtonIcon>{rightIcon}</ButtonIcon>}
        </>
      )}
    </StyledButton>
  );
};

export default Button;

